import React from 'react'
import PropTypes from 'prop-types'
import { getContext, withContext } from 'recompose'

export const connectConfig = getContext({ config: PropTypes.object })

export const ConfigProvider = withContext(
  { config: PropTypes.object },
  props => ({ config: props.config })
)(props => React.Children.only(props.children))
